const question4 = {
    'question': 'Czy jest możliwa wizyta domowa u pacjenta, który nie jest w stanie wyjść z domu?',
    'answer': 'Tak, wizyta domowa  u pacjenta, który nie jest w stanie wyjść z domu jest oferowana przez nasze Centrum w Toruniu. Aby umówić wizytę domową, pacjent lub opiekun powinien skontaktować się z lekarzem lub placówką medyczną. Jeśli wizyta domowa zostanie zatwierdzona, lekarz skontaktuje się z pacjentem, aby ustalić dogodny termin.',
}

export default question4;